import _ from 'lodash';
import { browserHistory } from 'react-router';
import toastr from 'toastr';
/** import third-party libraries in the section above, Sort Lines Ascending */

import { getApiErrorMessage } from 'utils/http/get-api-error-message';
import { serializeForApi } from './services';
import ActivateActions from 'states/resources/activate/actions';
import c from 'common/constants/flux-events';
/** import single application imports in the section above, Sort Lines Ascending */

export const activateEdit = {
    /**
     * Fetches activation token metadata from Urban and hydrates the form draft.
     *
     * @param {string} activation_token - 24-hex Mongo ObjectId from the activation link
     * @returns {Function} Redux thunk
     */
    open(activation_token) {
        return dispatch => {
            dispatch({
                type: c.ACTIVATION__DRAFT__OPEN,
                payload: { activation_token },
            });

            return dispatch(ActivateActions.get(activation_token))
                .then(response => {
                    dispatch({
                        type: c.ACTIVATION__DRAFT__FETCH__SUCCESS,
                        payload: { activation_token, activateAttr: { ...response } },
                    });
                    dispatch({
                        type: c.ACTIVATION__DRAFT__INIT,
                        payload: { activation_token, activateAttr: { ...response } },
                    });
                })
                .catch(error => {
                    let errorMessage = getApiErrorMessage(error, 'Invalid token');

                    if (error.code === 404) {
                        errorMessage =
                            'Invalid or expired activation token. Try to sign in. If you are unable to access your account, please contact us at help@engagefront.com';
                    }

                    dispatch({
                        type: c.ACTIVATION__DRAFT__FETCH__FAIL,
                        payload: {
                            activation_token,
                            fetchError: errorMessage,
                        },
                    });
                });
        };
    },

    updateDraft(formData) {
        return {
            type: c.ACTIVATION__DRAFT__UPDATE,
            payload: { formData },
        };
    },

    showErrors() {
        return {
            type: c.ACTIVATION__DRAFT__SHOW_ERRORS,
            payload: {},
        };
    },

    submitDraft() {
        return (dispatch, getState) => {
            const store_activation = _.get(getState(), `activate`, void 0);
            const errors = _.get(store_activation, `errors`, []);
            if (errors.length !== 0) {
                // There are errors dont do ajax
                dispatch({
                    type: c.ACTIVATION__DRAFT__SHOW_ERRORS,
                    payload: {
                        payloadSerialized: null,
                        activation_token: null,
                    },
                });
                return;
            }

            // No errors, essemble payload and serialize
            const draft = _.get(store_activation, `draft`, {});
            const activation_token = _.get(store_activation, `activation_token`, void 0);

            // Omit password fields on email-login path before POST (Urban validates when present).
            const { password, confirmPassword, password_strength, ...rest } = draft;
            const filteredDraft = {
                ...rest,
                ...(password ? { password, confirmPassword, password_strength } : {}),
            };

            // properties ignored in the API, as they are defined at user level
            delete filteredDraft.email;
            delete filteredDraft.email_login_enabled;

            const payload_beforeSerialized = {
                ...filteredDraft,
                activation_token: activation_token,
            };

            const payloadSerialized = serializeForApi(payload_beforeSerialized);
            // const payloadSerialized = payload_beforeSerialized;

            dispatch({
                type: c.ACTIVATION__DRAFT__SUBMIT,
                payload: { payloadSerialized },
            });

            dispatch(ActivateActions.update(payloadSerialized)).then(
                response => {
                    dispatch({
                        type: c.ACTIVATION__DRAFT__SUBMIT_SUCCESS,
                        payload: {
                            response,
                        },
                    });

                    toastr.success('Activation success.');

                    browserHistory.push(`/`);

                    dispatch({
                        type: c.ACTIVATION__DRAFT__CLOSE,
                    });
                },
                error => {
                    // Access-control decisions: frontend owns the copy.
                    if (error.code === 404) {
                        dispatch({
                            type: c.ACTIVATION__DRAFT__SUBMIT_FAIL,
                            payload: {},
                            error:
                                'Invalid or expired activation token. Try to sign in. If you are unable to access your account, please contact us at help@engagefront.com',
                        });
                        return;
                    }

                    dispatch({
                        type: c.ACTIVATION__DRAFT__SUBMIT_FAIL,
                        payload: {},
                        error: getApiErrorMessage(
                            error,
                            'An error has occurred, please try again.'
                        ),
                    });
                }
            );
        };
    },
};
